import React, { useState } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import TuneIcon from '@mui/icons-material/Tune';
import { useDispatch, useSelector } from 'react-redux';
import { Header } from '../../components/header/header';
import { ButtonIconStyled, TitleStyled } from './devicesStyles';
import Strings from '../../i18n';
import { DevicesTemplate } from '../../templates/device/devicesTemplate/devicesTemplate';
import { selectCurrentUser } from '../../store/slices/login/login';
import { viewRightSideBarEnum } from '../../constants/sidebarEnums';
import {
  systemModuleEnum,
  systemModulePermissionsEnum
} from '../../constants/systemRolesEnums';
import { setPermissionsReadWriteSystemDevices } from '../../store/slices/systemPermissions/systemPermissions';
import { ContainerStyled } from '../locations/locationStyles';
import { ReOpenSideBarIcon } from '../../components/commons/reOpenSideBarIcon/reOpenSideBarIcon';
import { RegisteredDevice } from '../../types/Device/DeviceInterfaces';

export const Devices = () => {
  const [openRightSideBar, setOpenRightSideBar] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedDevices, setSelectedDevices] = useState<RegisteredDevice[]>(
    []
  );
  const contextUser = useSelector(selectCurrentUser);
  const [sideBarOpenFor, setSideBarOpenFor] = useState(
    viewRightSideBarEnum.addDevice
  );
  const modulePermissions = contextUser.roleInfo.permissionsByModule.find(
    (module) => module.systemModuleName === systemModuleEnum.devices
  );

  const permissionReadWrite = !!modulePermissions?.permissions.includes(
    systemModulePermissionsEnum.readWrite
  );
  const openRightSideBarForMethod = (sideBarFor: number) => {
    setSideBarOpenFor(sideBarFor);
    setOpenRightSideBar(true);
  };

  dispatch(setPermissionsReadWriteSystemDevices(permissionReadWrite));
  const [searchValue, setSearchValue] = useState('');

  return (
    <div>
      <Header>
        <ContainerStyled>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIosIcon />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <TitleStyled>{Strings.serverAccess.menu.devices}</TitleStyled>
            </div>
            <div className="col-4 text-right">
              {permissionReadWrite && (
                <ButtonIconStyled
                  size="small"
                  onClick={() => {
                    setSideBarOpenFor(viewRightSideBarEnum.addDevice);
                    setOpenRightSideBar(true);
                  }}
                >
                  <AddCircleOutlineIcon />
                </ButtonIconStyled>
              )}
              {permissionReadWrite && (
                <ButtonIconStyled
                  size="small"
                  onClick={() => {
                    openRightSideBarForMethod(viewRightSideBarEnum.filters);
                  }}
                >
                  <TuneIcon />
                </ButtonIconStyled>
              )}
              <ReOpenSideBarIcon
                isOpenRightSideBar={openRightSideBar}
                selectedItems={selectedDevices}
                singleItemMethod={() => {
                  openRightSideBarForMethod(viewRightSideBarEnum.details);
                }}
                multipleItemsMethod={() => {
                  openRightSideBarForMethod(
                    viewRightSideBarEnum.editMultipleDevices
                  );
                }}
              />
            </div>
          </div>
        </ContainerStyled>
      </Header>
      <DevicesTemplate
        searchValue={searchValue}
        openRightSideBar={openRightSideBar}
        setOpenRightSideBar={setOpenRightSideBar}
        sideBarOpenFor={sideBarOpenFor}
        setSideBarOpenFor={setSideBarOpenFor}
        selectedDevices={selectedDevices}
        setSelectedDevices={setSelectedDevices}
      />
    </div>
  );
};
